var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-wrapper',{attrs:{"title":"Wallet"}},[_c('div',{staticClass:"page-container"},[_c('div',[_c('wallet-to-earn-user')],1),_vm._v(" "),_c('div',[_c('log-admin-report-by-feature',{attrs:{"target-feature":"TOKENX_TRANSACTION"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }